import { render, staticRenderFns } from "./VideosUpload.vue?vue&type=template&id=89b03bb4&scoped=true"
import script from "./VideosUpload.vue?vue&type=script&lang=js"
export * from "./VideosUpload.vue?vue&type=script&lang=js"
import style0 from "./VideosUpload.vue?vue&type=style&index=0&id=89b03bb4&prod&lang=less&scoped=true"
import style1 from "./VideosUpload.vue?vue&type=style&index=1&id=89b03bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b03bb4",
  null
  
)

export default component.exports